import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useCognitoAuth } from '@/contexts/AuthContext';

export function ResetPasswordPage() {
  const { user, signOut } = useCognitoAuth();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (!user) {
      void navigate('/forgot-password');
    }
  }, [user, navigate]);

  useEffect(() => {
    if (!user) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          void signOut();
          void navigate('/login?reset=success');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [user, signOut, navigate]);

  if (!user) {
    return null;
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <Link to="/" className="inline-block">
            <img src="/logo.png" alt="BeanGo" className="h-12 w-auto mx-auto mb-4" />
          </Link>
          <h1 className="text-2xl font-bold text-foreground">Password reset successful</h1>
          <p className="text-muted-foreground mt-2">
            Your password has been reset through the Cognito password reset flow.
          </p>
        </div>

        <div className="bg-card rounded-lg border border-border p-6 text-center">
          <div className="w-16 h-16 bg-green-100 dark:bg-green-950/30 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-green-600 dark:text-green-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <p className="text-sm text-muted-foreground mb-4">
            Redirecting to login in {countdown} seconds...
          </p>
          <Link
            to="/login?reset=success"
            className="inline-block w-full bg-primary text-primary-foreground py-2 rounded-lg font-semibold hover:bg-primary/90 transition-colors text-center"
          >
            Go to login now
          </Link>
        </div>
      </div>
    </div>
  );
}